import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { permissions } from '../../../../_constants/permissions'
import { hasPermission } from '../../../../_helper/hasPermission'
import { RouteWithPermission } from '../../../../_helper/routesWithPermission'
import { Error404 } from '../../../modules/errors/components/Error404'
import BehaviourNotesHeader from '../../../pages/Notes/Behaviour_Notes/BehaviourNotesHeader'
import { BehaviourListNotes } from '../../../pages/Notes/Behaviour_Notes/List'
import NewBehaviourNote from '../../../pages/Notes/Behaviour_Notes/new/New'
import EditBehaviourNote from '../../../pages/Notes/Behaviour_Notes/edit/Edit'
import BehaviourNotesAssessmentList from '../../../pages/Notes/Behaviour_Notes/assessment/List'
import BehaviourNotesAssessmentNew from '../../../pages/Notes/Behaviour_Notes/assessment/New'
import BehaviourNotesAssessmentEdit from '../../../pages/Notes/Behaviour_Notes/assessment/Edit'


export const BehaviourNotesIndexRoutes: React.FC = () => {
  const auth = useSelector((state: {auth: any}) => state.auth)
  const userPermissions = auth.user.roleId
  const canUpdate = hasPermission(userPermissions, permissions.notes_behavior_note_update)
  const canCreate = hasPermission(userPermissions, permissions.notes_behavior_note_create)
  const canRead = hasPermission(userPermissions, permissions.notes_behavior_note_view)
  const canCreateEntry = hasPermission(userPermissions, permissions.notes_behavior_note_entry_create)
  const canViewEntry = hasPermission(userPermissions, permissions.notes_behavior_note_entry_view)
  const canUpdateEntry = hasPermission(userPermissions, permissions.notes_behavior_note_entry_update)
  return (
    <>
    <BehaviourNotesHeader />
    <Switch>
      <RouteWithPermission
        path='/notes/behavior-notes/new/:id/:clientId/:noteType'
        component={NewBehaviourNote}
        hasPerm={canRead && canCreateEntry}
      />
      <RouteWithPermission
        path='/notes/behavior-notes/edit/:id'
        component={EditBehaviourNote}
        hasPerm={canRead && canUpdateEntry}
      />
      <RouteWithPermission
        path='/notes/behavior-notes/list/:id/:clientId/:noteType'
        component={BehaviourListNotes}
        hasPerm={canRead && canViewEntry}
      />
      <RouteWithPermission
        path='/notes/behavior-notes/list'
        component={BehaviourNotesAssessmentList}
        hasPerm={canRead}
      />
      <RouteWithPermission
        path='/notes/behavior-notes/new'
        component={BehaviourNotesAssessmentNew}
        hasPerm={canRead && canCreate}
      />
      <RouteWithPermission
        path='/notes/behavior-notes/:id'
        component={BehaviourNotesAssessmentEdit}
        hasPerm={canRead && canUpdate}
      />
      <Route path='/error/404' component={Error404} />
    </Switch>
    </>
  )
}
